
<div class="image-upload-root" *transloco="let t">
  <div class="picture" (click)="openUpdateImageModal()">
    <mat-icon class="image"
              id="icon-upload-input"
              *ngIf="!imgUrl">
              {{ icon }}
    </mat-icon>
    <img *ngIf="imgUrl" src="{{imgUrl}}" alt="{{ t('uploaded-image-alt') }}">
  </div>
  <app-anchor class="upload-file"
              (click)="openUpdateImageModal()">
              {{t('upload-file')}}
  </app-anchor>
</div>
